const KEY = "thf.signature.lastGood";
const norm = (from) => from?.toLowerCase() ?? null;
export async function saveLastGood(payload, from, auto = false) {
    try {
        const entry = { from: norm(from), payload, at: Date.now(), auto };
        // setItem returns a Promise — un-awaited, a rejection escaped the catch
        // and the "last good" cache silently never updated.
        await OfficeRuntime.storage.setItem(KEY, JSON.stringify(entry));
    }
    catch (err) {
        console.warn("[cache] saveLastGood failed:", err);
    }
}
/** Returns the cached payload only when it was fetched for the same
 *  from-address (both null = the default account). Mismatch → null.
 *  With `maxAgeMs`, an older, undated or non-automatic entry also → null. */
export async function loadLastGood(from, maxAgeMs) {
    try {
        const raw = await OfficeRuntime.storage.getItem(KEY);
        if (!raw)
            return null;
        const entry = JSON.parse(raw);
        if (entry.from !== norm(from))
            return null;
        if (maxAgeMs !== undefined &&
            !(entry.auto && entry.at && Date.now() - entry.at < maxAgeMs))
            return null;
        return entry.payload;
    }
    catch {
        return null;
    }
}
/** True when a fetch carried no per-message brand/badge option, i.e. the
 *  result is what an automatic compose would get. Derive this from the exact
 *  options object sent to the api, never from live pane state. */
export function isAutomatic(opts) {
    return (!opts.brandOverride &&
        !opts.forceMhfa &&
        !opts.forceDisclaimer &&
        !opts.forceTuv);
}
